import React from "react";
import Grid from "@material-ui/core/Grid";
import { colors } from "@material-ui/core";
import { useHeader } from "../bill-template02/style";
import { getTotalAmount } from "../../../utils/utils";
import tafqeet from "../../../utils/tafqeet";
import { styleFooterNotesAr } from "../ShareFunctionsPrint";

function NewTotalsCom(props) {
    const { found, sta, inv, premiApp, locInv } = props;
    const classHeader = useHeader();
    const styeNum = { fontWeight: "bold", textAlign: "right", paddingRight: "0.3rem", color: "#000", direction: "ltr" };
    const styleSecond = { fontWeight: "bold", textAlign: "right", direction: "ltr", paddingLeft: "0.3rem" };
    const tot_all = new Intl.NumberFormat('en-US', {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2,
    }).format(getTotalAmount(sta.tot));

    const tot_discount = new Intl.NumberFormat('en-US', {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2,
    }).format(sta.tot.discount);

    const tot_vat = new Intl.NumberFormat('en-US', {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2,
    }).format(sta.tot.amountOfVat);

    const tot_before = new Intl.NumberFormat('en-US', {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2,
    }).format(getTotalAmount(sta.tot) - sta.tot?.discount);

    const tot_net = new Intl.NumberFormat('en-US', {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2,
    }).format(sta.tot.tot_net);

    const tot_before_Re = new Intl.NumberFormat('en-US', {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2,
    }).format(getTotalAmount(sta.tot));
    const tot_net_Re = new Intl.NumberFormat('en-US', {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2,
    }).format(sta.tot.tot_net + sta.tot?.discount);



    const styRight = { textAlign: "right", backgroundColor: colors.grey[200] };
    return (
        <Grid item container
            justifyContent="center"
        >
            <Grid
                container
                item xs={12}
                style={{
                    fontWeight: "bold", fontFamily: "Amiri-Regular", paddingTop: "0.9rem",
                    marginLeft: "0cm", direction: "rtl"
                }}
            >
                <Grid container item xs={12}>
                    <Grid item xs={2} className={classHeader.rightHeaderar} >
                        {sta?.tot?.re_disc  ?
                            <>
                                <div style={styeNum}>{tot_before_Re}{" " + sta?.omlat[0]?.symbol ?? ""}</div>
                                <div style={styeNum}>{tot_vat} {" " + sta?.omlat[0]?.symbol ?? ""}</div>
                                <div style={styeNum}>{tot_net_Re} {" " + sta?.omlat[0]?.symbol ?? ""}</div>
                                <div style={styeNum}>{locInv?.desc_perc ?? 0} </div>{" "}
                                <div style={styeNum}>{tot_discount} {" " + sta?.omlat[0]?.symbol ?? ""}</div>
                                <div style={styeNum}>{tot_net} {" " + sta?.omlat[0]?.symbol ?? ""}</div>
                            </> :
                            <>
                                <div style={styeNum}>{tot_all}</div>
                                <div style={styeNum}>{tot_discount}</div>
                                <div style={styeNum}>{tot_before}</div>
                                <div style={styeNum}>{tot_vat}</div>{" "}
                                <div style={styeNum}>{tot_net}</div>
                            </>}
                    </Grid>
                    <Grid item xs={7} className={classHeader.leftHeaderen}>
                        {sta?.tot?.re_disc  ?
                            <>
                                <div style={styleSecond}>{"الإجمالي قبل الضريبة"}</div>
                                <div style={styleSecond}>{"("} {inv.tax}{"%"}{")"} {" مجموع ضريبة القيمة المضافة"}</div>{" "}
                                <div style={styleSecond}>{"الإجمالي شامل الضريبة"}</div>
                                <div style={styleSecond}>{"نسبة خصم ضمان الأعمال"}</div>
                                <div style={styleSecond}>{"مبلغ خصم ضمان الأعمال"}</div>
                                <div style={styleSecond}>{"الصافي المطلوب دفعه"}</div>
                            </> :
                            <>
                                <div style={styleSecond}>{"TOTAL SALE SR"}{"/"}{"الاجمالي"}</div>
                                <div style={styleSecond}>{"Discount"}{"/"}{"الخصم"}</div>
                                <div style={styleSecond}>{"Total Taxable Amount"}{"/"}{"الاجمالي الخاضع للضريبة"}</div>
                                <div style={styleSecond}>{"("} {inv.tax}{"%"}{")"}  {"VAT"}{"/"}{"الضريبة"}</div>{" "}
                                <div style={styleSecond}>{"Total Amt With Tax"}{"/"}{"المجموع فقط"}</div>
                                <div style={styleSecond}>{tafqeet(sta.tot.tot_net, "SAR")}</div>
                            </>}
                    </Grid>
                </Grid>
            </Grid>
            <Grid container item xs={12} style={{ paddingTop: "1.8rem" }}>
                <Grid item xs={5} style={{ fontFamily: "Amiri-Regular", fontWeight: "bold", textAlign: "center" }}>
                    {"توقيع المستلم"}
                    <br />
                    {"Sign Of Receiver"}
                </Grid>
                <Grid item xs={2} >
                </Grid>

                <Grid item xs={5} style={{ fontFamily: "Amiri-Regular", fontWeight: "bold", textAlign: "center" }}>
                    <div> {found.Disc1_header_ar} </div>
                    <div> {found.Disc1_header_en} </div>

                </Grid>
            </Grid>

        </Grid>
    );
}
export default NewTotalsCom;